import React from "react";
import { connect } from "react-redux";
import {
  serviceCaller,
  ServiceCallerProps,
  withLoginRedirect,
  ModalProps,
  withModals,
} from "../../composition";
import { firebaseConnect, isEmpty, isLoaded } from "react-redux-firebase";
import { Row, Col, Button, Label } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";
import get from "lodash.get";
import isEqual from "lodash.isequal";
import ISegment from "../../../types/services/ISegment";

import Dashboard from "../../components/dashboard";
import Fragment from "../../../toolkit/fragment";
import classNames from "classnames";
import {
  searchDonorsByIdsExtended,
  deleteDonorKeyword,
} from "../../../utils/fetch";
import ISelectionUpdate from "../../../types/ISelectionUpdate";
import IColumnName from "../../../types/IColumnName";
import {
  applyColumnPrefs,
  TableIds,
  toggleSavedColumn,
} from "../../../utils/tablePrefs";
import { ExportType } from "../exportModal";
import IUser from "../../../types/services/IUser";
import * as commonActions from "../../../utils/actions/common";
import { ScaleLoader } from "react-spinners";
import {
  isCurrentUserCollaborator,
  isCurrentUserOnlyCollaborator,
  isCurrentUserOnlyReader,
} from "../../../utils/roleCheck";
import firebase from "firebase/compat/app";
import { withRouter } from "../../../utils/withRouter";

interface IExtendedUser extends IUser {
  keywordDateStr: string;
}

interface Props extends ServiceCallerProps, ModalProps {
  segment: ISegment;
  firebase: firebase.app.App;
  refreshDashboard: () => void;
  selectElement: (quantity: string, message: string) => void;
  flagIds: { [key: string]: boolean };
  allSegments: { [key: string]: ISegment }[];
}

interface State {
  selectAll: boolean;
  selectedIds: string[];
  suppressedIds: string[];
  totalResult: number;
  keywordsDonors: Array<IExtendedUser>;
  keywordsDonorsIds: Array<String>;
  fetchForSegment: boolean;
  loading: boolean;
  nameError: boolean;
  wipeData: boolean;
  columnNames: Array<IColumnName>;
}

class KeywordDonorList extends React.PureComponent<Props, State> {
  state = {
    sortBy: { key: "PHONE", show: "Mobile #", colName: "phoneNumber" },
    selectAll: false,
    sortAsc: true,
    selectedIds: [],
    suppressedIds: [],
    totalResult: 0,
    keywordsDonors: [],
    keywordsDonorsIds: [],
    fetchForSegment: true,
    loading: true,
    nameError: false,
    wipeData: false,
    columnNames: applyColumnPrefs(TableIds.keywordDonors, [
      { key: "First Name", isDisabled: false },
      { key: "Last Name", isDisabled: false },
      { key: "Mobile #", isDisabled: false },
      { key: "Subscription Date", isDisabled: false },
      { key: "Origin", isDisabled: false },
      { key: "Created On", isDisabled: false },
    ]),
  };

  columnData = [
    "firstName",
    "lastName",
    "phoneNumber",
    "keywordDateStr",
    "originPretty",
    "createdOnPretty",
  ];

  componentDidMount() {
    if (
      this.props.config &&
      this.props.currentCharity &&
      this.props.segment &&
      this.props.serviceAccessToken
    ) {
      this.fetchDonors(null);
    }
    if (window) {
      this.handleWindowSize();
      window.addEventListener("resize", this.handleWindowSize);
    }
    if (this.props.currentCharity) {
      if (isCurrentUserOnlyCollaborator(this.props.currentCharity)) {
        this.props.navigate("/viewsparks");
      }
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (
      this.props.config &&
      this.props.currentCharity &&
      this.props.segment &&
      this.props.serviceAccessToken
    ) {
      this.fetchDonors(prevProps.flagIds);
    }
    if (this.props.currentCharity) {
      if (isCurrentUserOnlyCollaborator(this.props.currentCharity)) {
        this.props.navigate("/viewsparks");
      }
    }
  }

  componentWillUnmount() {
    if (window) {
      window.removeEventListener("resize", this.handleWindowSize);
    }
  }

  handleWindowSize = () => {
    if (window) {
      this.setState({
        columnNames: applyColumnPrefs(TableIds.keywordDonors, [
          { key: "First Name", isDisabled: false },
          { key: "Last Name", isDisabled: false },
          { key: "Mobile #", isDisabled: false },
          { key: "Subscription Date", isDisabled: false },
          { key: "Origin", isDisabled: false },
          { key: "Created On", isDisabled: false },
        ]),
      });
    }
  };

  selectAllCheck = e => {
    this.setState({
      selectAll: e.target.checked,
    });
  };

  selectionUpdate = (update: ISelectionUpdate) => {
    this.setState({
      totalResult: update.totalAmount,
      selectedIds: update.selectedIds,
      suppressedIds: update.suppressedIds,
    });
  };

  execExport = () => {
    this.props.toggleExportModal(
      ExportType.keywords,
      undefined,
      this.state.keywordsDonors.length.toString(),
      undefined,
      undefined,
      undefined,
      undefined,
      this.props.segment.name,
      this.props.segment.isDonorList,
      this.props.flagIds ? Object.keys(this.props.flagIds) : [""],
      this.props.params.segmentId
    );
  };

  customCompare = fieldName => {
    return (a, b) => {
      if (!a[fieldName]) {
        return 1;
      } else if (!b[fieldName]) {
        return -1;
      } else if (a[fieldName] === b[fieldName]) {
        return 0;
      } else if (a[fieldName] < b[fieldName]) {
        return -1;
      } else {
        return 1;
      }
    };
  };

  getSubscribeDate = (user: IUser): string => {
    let subscribeDate = "Not available";

    if (this.props.segment && user.keywordsSubscriptionDatesPretty) {
      const keywordId = this.props.params.segmentId;
      subscribeDate =
        user.keywordsSubscriptionDatesPretty[keywordId] != undefined
          ? user.keywordsSubscriptionDatesPretty[keywordId]
          : "Not available";
    }
    return subscribeDate;
  };

  getOrigin = (user: IUser): string => {
    if (user.originPretty === "Sms") {
      return "Keyword";
    }
    return user.originPretty ? user.originPretty : "Not available";
  };

  fetchDonors = prevIds => {
    if (
      this.props.segment.isDonorList &&
      !isEqual(prevIds, this.props.flagIds)
    ) {
      searchDonorsByIdsExtended(
        this.props.config.searchServiceUrl,
        this.props.currentCharity.id,
        this.props.flagIds ? Object.keys(this.props.flagIds) : [""],
        this.props.serviceAccessToken
      ).then(response => {
        let responseExtended = response
          ? response.map(user => {
              let extended = {
                ...user,
                phoneNumber: user.phoneNumber
                  ? user.phoneNumber
                  : "Not available",
                keywordDateStr: this.getSubscribeDate(user),
                originPretty: this.getOrigin(user),
              };
              return extended;
            })
          : [];
        this.setState(
          {
            keywordsDonors: responseExtended,
            keywordsDonorsIds: this.props.flagIds
              ? Object.keys(this.props.flagIds)
              : [""],
            loading: false,
          },
          () => {
            this.props.refreshDashboard();
          }
        );
      });
    }
  };

  deleteDonors = () => {
    if (!this.state.selectAll && this.state.selectedIds.length === 0) {
      alert("Please select at least one contact to remove");
    } else {
      if (confirm("Are you sure you want to delete these contacts?")) {
        let deleteIds = [];

        if (this.state.selectAll && this.state.suppressedIds.length > 0) {
          deleteIds = this.props.flagIds
            ? [...Object.keys(this.props.flagIds)]
            : [""];
          this.state.suppressedIds.forEach(elem => {
            deleteIds.splice(deleteIds.indexOf(elem), 1);
          });
        } else if (this.state.selectAll) {
          deleteIds = this.props.flagIds
            ? [...Object.keys(this.props.flagIds)]
            : [""];
        } else if (this.state.selectedIds.length > 0) {
          deleteIds = [...this.state.selectedIds];
          this.props.selectElement("0", "Donors Selected");
        }

        this.setState(
          {
            selectAll: false,
            selectedIds: [],
            suppressedIds: [],
            wipeData: true,
          },
          () => {
            deleteDonorKeyword(
              this.props.config.adminServiceUrl,
              this.props.currentCharity.id,
              deleteIds,
              this.props.serviceAccessToken,
              this.props.params.segmentId
            ).then(response => {
              setTimeout(() => {
                alert(response);
                this.setState({
                  wipeData: false,
                });
              }, 3000);
            });
          }
        );
      }
    }
  };

  getResponse = (currentPage, pageSize) => {
    const result = [];
    for (
      let i = pageSize * currentPage;
      i < pageSize * (currentPage + 1) && i < this.state.keywordsDonors.length;
      i++
    ) {
      result.push(this.state.keywordsDonors[i]);
    }
    return Promise.resolve({
      result: result,
      totalAmount: this.state.keywordsDonors.length,
      pageAmount: Math.ceil(this.state.keywordsDonors.length / pageSize),
      time: Date.now(),
    });
  };

  goBack = () => {
    this.props.navigate(-1);
  };

  disableColumn = index => {
    const copy = toggleSavedColumn(
      TableIds.keywordDonors,
      this.state.columnNames,
      index
    );
    this.setState(
      {
        columnNames: copy,
      },
      () => {
        this.props.columnsModalChange(this.state.columnNames);
      }
    );
  };

  changeColumns = () => {
    this.props.toggleColumnsModal(this.disableColumn, this.state.columnNames);
  };

  render() {
    const { segment } = this.props;
    return (
      <main className={s.main}>
        <div className={s.container}>
          <Row>
            <Col xs={1} className={s.noPadding}>
              <div onClick={this.goBack} className={s.cursor}>
                <div className={s.arrowLeftContainer}>
                  <div className={s.arrowLeft} />
                </div>
                <Label className={classNames(s.backLabel, s.cursor)}>
                  Back
                </Label>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12} className={s.titleMargin}>
              {segment && (
                <Fragment>
                  <span className={s.title}>
                    {segment.name ? segment.name : ""}
                  </span>
                </Fragment>
              )}
            </Col>
          </Row>
          <Row className={s.marginBot}>
            <Col xs={12} md={2} className={s.colMargin}>
              <div className={s.inlineCheck}>
                <input
                  id="selectAll"
                  name="selectAll"
                  type="checkbox"
                  checked={this.state.selectAll}
                  onChange={this.selectAllCheck}
                />
                <label
                  className={
                    this.state.selectAll
                      ? this.state.suppressedIds.length > 0
                        ? s.checkSome
                        : s.checkAll
                      : s.noCheck
                  }
                  htmlFor="selectAll"
                />
              </div>
            </Col>

            {this.props.segment &&
              this.props.segment.isDonorList &&
              isCurrentUserCollaborator(this.props.currentCharity) && (
                <Col xs={12} md={5} className={s.colMargin}>
                  <Button
                    className={s.button}
                    color={"none"}
                    onClick={this.deleteDonors}
                  >
                    Remove Contact
                  </Button>
                </Col>
              )}
            <Col
              xs={12}
              md={{
                offset:
                  this.props.segment &&
                  this.props.segment.isDonorList &&
                  !isCurrentUserOnlyReader(this.props.currentCharity)
                    ? 0
                    : 5,
                size: 5,
              }}
              className={s.colMargin}
            >
              <Button
                className={s.button}
                color={"none"}
                onClick={this.execExport}
              >
                Export All
              </Button>
            </Col>
          </Row>
          <Row>
            {this.props.serviceAccessToken &&
              this.props.config &&
              !this.state.loading && (
                <Dashboard
                  tableId={TableIds.keywordDonors}
                  columnNames={this.state.columnNames}
                  columnData={this.columnData}
                  selectionUpdate={this.selectionUpdate}
                  checkCol={
                    this.props.segment ? this.props.segment.isDonorList : false
                  }
                  noDataText={"No Donors Found"}
                  infoCol={false}
                  selectAll={this.state.selectAll}
                  sortAsc={this.state.sortAsc}
                  footerMessage={
                    this.props.segment && this.props.segment.isDonorList
                      ? "Donors Selected"
                      : "Donors"
                  }
                  currentCharity={this.props.currentCharity}
                  getResponse={this.getResponse}
                  wipeData={this.state.wipeData}
                  deactivatedClassName={"deactivatedLabel"}
                />
              )}
            {this.state.loading && (
              <div
                className={
                  "d-flex full-width justify-content-center m-t-200 m-b-300 " +
                  s.center
                }
              >
                <ScaleLoader color={"#1f65b1"} loading />
              </div>
            )}
          </Row>
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { firebase, user } = state;
  const segment = get(
    firebase,
    `data.${user.currentCharity.id}.segments.${props.params.segmentId}`
  );
  const flagIds =
    segment &&
    isLoaded(firebase.data[user.currentCharity.id]) &&
    isLoaded(firebase.data[user.currentCharity.id].donorsFlags) &&
    isLoaded(
      firebase.data[user.currentCharity.id].donorsFlags[segment.donorListId]
    )
      ? !isEmpty(
          firebase.data[user.currentCharity.id].donorsFlags[segment.donorListId]
        )
        ? get(
            firebase,
            `data.${user.currentCharity.id}.donorsFlags.${segment.donorListId}`
          )
        : []
      : null;
  const segments = !get(firebase, `data.${user.currentCharity.id}.segments`)
    ? null
    : get(firebase, `ordered.${user.currentCharity.id}.segments`);

  return {
    segment: segment,
    flagIds: flagIds,
    allSegments: segments,
  };
};

const mapDispatchToProps = dispatch => ({
  selectElement: (quantity = null, message = null) => {
    dispatch(commonActions.selectElement(quantity, message));
  },
  refreshDashboard: () => {
    dispatch(commonActions.refreshDashboard());
  },
});

export default serviceCaller(
  withLoginRedirect(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(
      withModals(
        firebaseConnect((props, store) => {
          const charityId = store.getState().user.currentCharity.id;
          const segmentId = props.params.segmentId;
          if (charityId && segmentId) {
            let paths = [
              { path: `${charityId}/segments/${segmentId}` },
              { path: `${charityId}/segments` },
            ];
            props.segment && props.segment.isDonorList
              ? paths.push({
                  path: `${charityId}/donorsFlags/${props.segment.donorListId}`,
                })
              : paths;
            return paths;
          } else {
            return [];
          }
        })(withStyles(s)(withRouter(KeywordDonorList)))
      )
    )
  )
);
